import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { rgba } from "polished";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const HeadingSubtitle = styled(Paragraph)`
  display: inline-block;
`;

export const LinkText = styled(Link)`
  margin-bottom: 0;
`;

export const FreeAndUnlimitedNote = styled.div`
  border-radius: 16px;
  padding: 1px 6px 3px;
  background-color: ${rgba(vars.colors.green, 0.2)};

  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: ${vars.colors.green};
`;
